const PriceCheckerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 96 96"
    width={100}
    height={100}
  >
    <path
      fill="#FDC221"
      d="M60.482 29.024c.323-.327.5-.76.496-1.22a1.714 1.714 0 0 0-.511-1.222 1.708 1.708 0 0 0-1.209-.497h-.01a1.726 1.726 0 0 0-1.72 1.732l.011 1.718h.004v.01l1.725-.01a1.71 1.71 0 0 0 1.214-.511ZM56.163 30.916H53.65v11.131h2.513V30.916ZM50.549 26.085a1.725 1.725 0 1 0-.009 3.45h1.73v-1.729c0-.949-.772-1.721-1.721-1.721Z"
    />
    <path
      fill="#FDC221"
      d="M70.242 25.07c0-8.473-6.87-15.342-15.343-15.342-8.474 0-15.343 6.869-15.343 15.342 0 6.448 3.981 11.957 9.615 14.227v2.75h3.098v-11.13H50.54a3.107 3.107 0 1 1 3.11-3.11v1.728h2.508l-.01-1.71a3.081 3.081 0 0 1 .894-2.199 3.08 3.08 0 0 1 2.189-.921c.859-.034 1.617.312 2.206.894.59.583.917 1.36.922 2.188a3.085 3.085 0 0 1-.895 2.207 3.08 3.08 0 0 1-2.188.922l-1.733.01v11.122h3.707v-3.023c5.3-2.417 8.992-7.749 8.992-13.954Z"
    />
    <path
      fill="#fff"
      d="M50.54 29.535a1.725 1.725 0 1 1 .009-3.45c.949 0 1.72.772 1.72 1.72v1.73h1.381v-1.73a3.107 3.107 0 1 0-3.11 3.11h1.73v-1.38h-1.73ZM57.528 27.817a1.726 1.726 0 0 1 1.72-1.732h.01c.456 0 .884.176 1.209.497.327.323.509.754.511 1.222a1.71 1.71 0 0 1-.496 1.22 1.71 1.71 0 0 1-1.214.511l-1.725.01v1.381l1.733-.01a3.08 3.08 0 0 0 2.188-.922c.582-.59.9-1.37.895-2.207a3.079 3.079 0 0 0-.922-2.188c-.589-.582-1.347-.928-2.206-.895a3.081 3.081 0 0 0-2.189.922 3.08 3.08 0 0 0-.895 2.199l.01 1.71h1.382l-.01-1.718Z"
    />
    <path
      fill="#fff"
      d="M53.65 30.916h2.513v11.131h1.38V29.535H52.27v12.512h1.38V30.916Z"
    />
    <path
      fill="#F470BD"
      d="M56.163 42.048h-8.29v3.646a7.013 7.013 0 0 0 7.013 7.013h.025a7.013 7.013 0 0 0 7.013-7.013v-3.646h-5.761Zm3.26 6.837h-8.898v-1.15h8.898v1.15Zm0-2.91h-8.898v-1.15h8.898v1.15Z"
    />
    <path
      fill="#E60278"
      d="M59.423 44.824h-8.898v1.15h8.898v-1.15ZM59.423 47.733h-8.898v1.151h8.898v-1.15Z"
    />
    <path
      fill="#FDC221"
      d="M34.34 25.618h-2.924a1.036 1.036 0 0 1 0-2.071h2.924a1.036 1.036 0 1 1 0 2.071ZM77.757 25.618h-2.923a1.036 1.036 0 0 1 0-2.071h2.923a1.036 1.036 0 1 1 0 2.071ZM54.899 5.37a1.036 1.036 0 0 1-1.036-1.035V1.412a1.036 1.036 0 1 1 2.071 0v2.923c0 .572-.463 1.036-1.035 1.036Z"
    />
    <path
      fill="#FDC221"
      d="M34.652 25.618h-2.924a1.036 1.036 0 0 1 0-2.071h2.924a1.036 1.036 0 1 1 0 2.071ZM78.07 25.618h-2.924a1.036 1.036 0 1 1 0-2.071h2.923a1.036 1.036 0 1 1 0 2.071ZM69.215 11.302a1.036 1.036 0 0 1-.732-1.768l2.067-2.068a1.036 1.036 0 0 1 1.465 1.465l-2.067 2.067a1.032 1.032 0 0 1-.733.304ZM40.582 11.302c-.265 0-.53-.101-.732-.304l-2.067-2.067a1.036 1.036 0 0 1 1.465-1.465l2.066 2.068a1.036 1.036 0 0 1-.732 1.768Z"
    />
    <path
      fill="#FDC221"
      d="M34.652 25.618h-2.924a1.036 1.036 0 0 1 0-2.071h2.924a1.036 1.036 0 1 1 0 2.071ZM78.07 25.618h-2.924a1.036 1.036 0 1 1 0-2.071h2.923a1.036 1.036 0 1 1 0 2.071Z"
    />
    <path
      fill="#AF6E37"
      d="M65.129 46.094c-1.344-.098-2.707.625-3.54 1.65-1.123 1.38-1.506 3.212-1.692 4.98-.171 1.628.166 3.716.038 4.945-.046.437-.17.826-.341 1.176-.03.029-.061.059-.083.087-4.978 6.38-11.318-3.203-11.672-3.758-1.56-2.444-1.896-4.452-1.578-6.534.53-3.47 2.509-6.473 2.12-8.142-.608-2.619-3.036-2.848-4.728-1.9-1.462.819-3.426 5.204-3.85 6.826-.563 2.147-1.65 6.758.594 11.515-.048-.029-3.64-2.406-5.883-7.025-1.802-3.712-2.012-8.162-3.66-9.903-2.493-2.634-6.706.337-5.89 4.223-.127-.6 1.08 5.38 2.907 9.075 1.755 3.548 3.674 6.004 4.704 7.346.031.04.656.74 1.11 1.338-1.689-.93-3.95-2.54-5.03-3.56-1.995-1.88-3.59-4.487-5.435-6.022-3.194-2.657-6.751.89-4.666 4.485 1.306 2.25 3.664 5.216 5.903 7.378 2.854 2.757 5.867 4.598 6.49 5.071.101.076 2.063 1.323 2.063 1.323s-2.782-.697-5.998-2.5c-1.824-1.021-3.45-2.565-4.263-2.946-3.63-1.7-5.634 2.47-3.373 5.101.319.371 1.661 1.745 5.045 3.932s6.167 3.39 7.923 4.21c5.914 2.76 10.946 4.728 12.446 5.094 1.81.441 3.456.663 4.966.594l6.468 9.077v.001l.035.048.002-.002c1.72 2.281 7.248 1.162 12.406-2.528 5.133-3.671 7.975-8.51 6.423-10.887l.005-.003-7.32-10.503c.32-.908.585-1.731.75-2.398.136-.553.251-1.751.327-2.706.067-.857-.001-1.721-.207-2.556-1.01-4.102-1.476-7.674-1.475-12.032 0-1.663-.052-3.425-2.041-3.57Z"
    />
    <path
      fill="#994D1D"
      d="M52.2 73.734a.75.75 0 0 1-.582-.276c-.155-.189-3.898-4.629-10.288-2.604a.75.75 0 1 1-.453-1.43c7.38-2.343 11.86 3.032 11.905 3.087a.75.75 0 0 1-.582 1.223Z"
    />
  </svg>
);

export default PriceCheckerIcon;
